module.exports = __webpack_public_path__ + "img/logotipo_chame.5279dbf9.png";